import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user/$guid')({
  component: () => <div>Hello /_authenticated/user/$guid!</div>,
})
